import { render, staticRenderFns } from "./Vue.Svg.Icon.vue?vue&type=template&id=3457c185&scoped=true&"
import script from "./Vue.Svg.Icon.vue?vue&type=script&lang=js&"
export * from "./Vue.Svg.Icon.vue?vue&type=script&lang=js&"
import style0 from "./Vue.Svg.Icon.vue?vue&type=style&index=0&id=3457c185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3457c185",
  null
  
)

export default component.exports